<template>
  <div class="home">
    <div class="messbox">
      <transition name="slide">
        <div v-if="message.show" :class="['message', message.type]">
          {{ message.text }}
        </div>
      </transition>
    </div>
    <div class="header">
      <img class="logo" src="@/assets/logo.png"/>
      <div class="name">Hit Fortune Subscription Preferences</div>
    </div>
    <div>
      <div class="banner">
        <!-- 背景图改成 CSS background，不再用 img -->
        <div class="banner_bg"></div>

        <!-- 顶部信息卡片 -->
        <div class="page">
          <div class="page_title">Here you can change your email/sms sending preferences.</div>

          <div class="tip">Please select the categories you wish to receive communications from</div>

          <!-- 三个复选框，默认全部选中 -->
          <label v-for="(c, i) in checks" :key="c.key" class="row">
            <div class="line"></div>
            <div class="item">
              <input type="checkbox" v-model="c.checked" />
              <div class="content">
                <span>{{ c.label }}</span>
                <div>{{ checksContent[i] }}</div>
              </div>
            </div>
            <div class="line" v-if="i == checks.length - 1"></div>
          </label>

          <button class="update_btn" @click="update()">Update Subscriptions</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
// import "@/css/home.css"
import { ref } from 'vue'
document.getElementById("body").style.backgroundColor = "#2c1f4d";
// 复选框数据
const checks = ref([
  { key: 'news', label: 'Newsletter', checked: true },
  { key: 'sms', label: 'SMS', checked: true },
  { key: 'push', label: 'Push', checked: true }
])
const checksContent = ref([
  "Promotional emails and account rewards",
  "Promotional SMS and account rewards",
  "Promotional push notifications and account rewards",
])
// 消息状态
const message = ref({
  show: false,
  text: 'Error: No valid email information provided.',
  type: 'error' // 或 'error', 'warning' 等
})

const update = () => {
  message.text = 'Error: No valid email information provided.';
  message.type = 'error';
  message.value.show = true;
  
  setTimeout(() => {
    message.value.show = false;
  }, 3000);

}

window.onload = function () {
  // 触发resize事件，以便在页面加载时立即进行尺寸检查
  window.dispatchEvent(new Event('resize'));
};
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
}

html,
body {
  /*width: 100%;*/
  width: 1920px;
  overflow-x: auto;
  background-color: #2c1f4d;
  padding: 0;
  margin: 0px auto;
}

span {
  color: #269EFA;
}

.home {
  /*width: 100%;*/
  width: 1920px;
  height: 1080px;
}

.header {
  position: absolute;
  /*width: 100%;*/
  width: 1920px;
  height: 80px;
  background-color: #4022B3;
  display: flex;
  justify-content: center;
  align-items: center;
}

.logo {
  position: absolute;
  left: 0;
  margin-left: 30px;
  width: 72px;
  height: 72px;
}

.banner {
  position: absolute;
  /*width: 100%;*/
  width: 1920px;
  height: 1000px;
  margin-top: 80px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.banner_bg {
  position: absolute;
  /*width: 100%;*/ 
  width: 1920px;
  height: 1000px;
  background-image: url('../assets/banner_bg.png');
  /*background-repeat: repeat-y;
   垂直平铺 
   不缩放，保持原图尺寸 */
   background-position: top center;
   background-size: auto;
}

.name {
  position: absolute;
  font-family: Microsoft YaHei;
  font-weight: bold;
  font-size: 30px;
  font-size: clamp(20px, 1.56vw, 30px);
  color: #FFFFFF;
}


/* 白色卡片，居中 */
.page {
  position: absolute;
  /*width: 100%;*/
  width: 980px;
  height: 600px;
  margin-top: -100px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  padding: 40px 80px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}

.page_title {
  font-size: 24px;
  font-weight: bold;
  text-align: center;
  /*width: 100%;*/
  /* border: 1px solid #E6DBFF; */
  padding: 30px 0px;
  background-color: #E6DBFF;
  border-radius: 10px;
}

.tip {
  text-align: center;
  font-weight: 300;
  font-size: 20px;
  margin-top: 30px;
  margin-bottom: 50px;
}

.item {
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.content {
  font-size: 15px;
}
.content span {
  color: #000;
  font-weight: bold;
}

/* 隐藏原生 checkbox */
.item input[type="checkbox"] {
  display: none;
}

/* 圆圈 */
.item:has(input[type="checkbox"]) .content {
  position: relative;
  padding-left: 32px;
  /* 留空给伪元素 */
}

.item .content::before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  width: 20px;
  height: 20px;
  border: 2px solid #000;
  background: #fff;
  border-radius: 50%;
  transition: all .2s ease;
}

/* 选中态 */
.item:has(input:checked) .content::before {
  background: #1976d2;
  border-color: #1976d2;
}

/* 对钩 */
.item:has(input:checked) .content::after {
  content: "";
  position: absolute;
  left: 7px;
  top: 3px;
  width: 5px;
  height: 10px;
  border: solid #fff;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}

.line {
  /*width: 100%;*/
  height: 1px;
  background-color: #E3E3E3;
}

.update_btn {
  text-align: center;
  margin: 0 auto;
  margin-top: 60px;
  width: 250px;
  padding: 20px 30px;
  color: white;
  font-size: 18px;
  background-color: #2299FE;
  border-radius: 15px;
  border: none;
  cursor: pointer;
}
.message {
  position: fixed;
  font-size: 16px;
  top: 100px;
  left: 50%;
  transform: translateX(-50%);
  padding: 15px 20px;
  border-radius: 5px;
  color: white;
  font-weight: bold;
  z-index: 1000;
  min-width: 300px;
  text-align: center;
}

.message.error {
  background-color: red;
}

/* 滑动动画 */
.slide-enter-active {
  transition: all 0.3s ease-out;
}

.slide-leave-active {
  transition: all 0.3s ease-in;
}

.slide-enter-from {
  opacity: 0;
  transform: translate(-50%, -30px); /* 从上方滑入 */
}

.slide-enter-to {
  opacity: 1;
  transform: translate(-50%, 0); /* 到达当前位置 */
}

.slide-leave-from {
  opacity: 1;
  transform: translate(-50%, 0); /* 从当前位置开始 */
}

.slide-leave-to {
  opacity: 0;
  transform: translate(-50%, -30px); /* 向上滑出 */
}

.messbox {
  position: relative;
  /*width: 100%;*/
  display: flex;
  justify-content: center;
}

</style>
